import { Phone, Instagram, Clock } from "lucide-react";
import { BIZ, PHONE_TEL, IMAGES } from "../data";
import Reveal from "../components/Reveal";
import { CtaButton, WaIcon } from "../components/Cta";

export default function Contact() {
  return (
    <section
      id="contato"
      className="relative overflow-hidden border-t border-[--gold]/20 bg-[#080808] py-24 sm:py-32"
      data-testid="contact-section"
    >
      <div className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[420px] -translate-x-1/2 rounded-full bg-[--gold] opacity-[0.08] blur-[140px]" />

      <div className="relative mx-auto max-w-6xl px-5 text-center sm:px-8">
        <Reveal>
          <span className="font-display text-sm font-semibold uppercase tracking-[0.35em] text-[--gold]">
            Sua avaliação começa aqui
          </span>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mx-auto mt-5 max-w-4xl font-display text-5xl font-black uppercase leading-[0.9] tracking-tight text-white sm:text-7xl md:text-8xl">
            Comece <span className="text-[--gold] gold-glow">agora</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-neutral-300 sm:text-lg">
            Agende sua avaliação física pelo WhatsApp e dê o primeiro passo para um treino feito só
            para você.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-10 flex justify-center">
            <CtaButton size="lg" testid="final-whatsapp-btn" />
          </div>
        </Reveal>

        {/* Contact grid */}
        <div className="mt-16 grid grid-cols-1 gap-4 text-left sm:grid-cols-3">
          <Reveal>
            <a
              href={PHONE_TEL}
              data-testid="contact-phone"
              className="group flex h-full flex-col border border-[--gold]/15 bg-black p-6 transition-colors duration-300 hover:border-[--gold]/50"
            >
              <Phone className="h-6 w-6 text-[--gold]" />
              <span className="mt-4 text-xs uppercase tracking-widest text-neutral-400">Telefone</span>
              <span className="font-display text-lg font-bold text-white group-hover:text-[--gold]">
                {BIZ.phoneDisplay}
              </span>
            </a>
          </Reveal>
          <Reveal delay={0.06}>
            <a
              href={BIZ.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-instagram"
              className="group flex h-full flex-col border border-[--gold]/15 bg-black p-6 transition-colors duration-300 hover:border-[--gold]/50"
            >
              <Instagram className="h-6 w-6 text-[--gold]" />
              <span className="mt-4 text-xs uppercase tracking-widest text-neutral-400">Instagram</span>
              <span className="font-display text-lg font-bold text-white group-hover:text-[--gold]">
                {BIZ.instagramHandle}
              </span>
            </a>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="flex h-full flex-col border border-[--gold]/15 bg-black p-6">
              <Clock className="h-6 w-6 text-[--gold]" />
              <span className="mt-4 text-xs uppercase tracking-widest text-neutral-400">Horário</span>
              <span className="font-display text-sm font-bold leading-snug text-white">
                Seg–Sex 06–20h · Sáb 08–11h
              </span>
            </div>
          </Reveal>
        </div>
      </div>

      {/* Footer */}
      <footer className="relative mx-auto mt-20 max-w-7xl border-t border-white/10 px-5 pt-10 sm:px-8">
        <div className="flex flex-col items-center justify-between gap-6 sm:flex-row">
          <div className="flex items-center gap-3">
            <img src={IMAGES.logo} alt="+5 Studio Training" className="h-12 w-auto" />
            <div className="font-display leading-tight">
              <div className="text-lg font-bold uppercase text-white">{BIZ.name}</div>
              <div className="text-xs uppercase tracking-widest text-neutral-500">
                {BIZ.trainer} · {BIZ.cref}
              </div>
            </div>
          </div>
          <div className="flex items-center gap-6">
            <a href={BIZ.instagramUrl} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-neutral-400 transition-colors duration-300 hover:text-[--gold]">
              <Instagram className="h-5 w-5" />
            </a>
            <a href={PHONE_TEL} aria-label="Telefone" className="text-neutral-400 transition-colors duration-300 hover:text-[--gold]">
              <Phone className="h-5 w-5" />
            </a>
            <a href="https://wa.me/5511997284470" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="text-neutral-400 transition-colors duration-300 hover:text-[#25D366]">
              <WaIcon className="h-5 w-5" />
            </a>
          </div>
        </div>
        <div className="mt-8 pb-8 text-center text-xs text-neutral-600">
          © {new Date().getFullYear()} {BIZ.name} — {BIZ.address.city}. Todos os direitos reservados.
        </div>
      </footer>
    </section>
  );
}
